<mx-component-lib-section titleText="Checkboxes">
  <mx-action-buttons>
    <mx-elevated-button [label]="allCheckboxesChecked ? 'Uncheck All' : 'Check All'" (click)="allCheckboxesChecked = !allCheckboxesChecked"/>
    <mx-elevated-button [label]="allCheckboxesDisabled ? 'Enable All' : 'Disable All'" (click)="allCheckboxesDisabled = !allCheckboxesDisabled"/>
  </mx-action-buttons>

  <mat-checkbox color="primary" [disabled]="allCheckboxesDisabled" [checked]="allCheckboxesChecked">primary</mat-checkbox>
</mx-component-lib-section>
